import {Injectable, OnDestroy} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {BehaviorSubject} from 'rxjs';
import {StorageService} from './storage.service';
import {Club, Customer} from '../models';
import {BreadcrumbTranslationService} from 'src/app/shared/translations';

/**
 * Service for sidebar properties
 */
@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class NavigationService implements OnDestroy {
  public selectedClubId: number = 0;
  public customer: Customer;
  public currentId: number = 0;

  public currentPage: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public castCurrentPage: any = this.currentPage.asObservable();

  public currentBreadcrumbs: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public castCurrentBreadcrumbs: any = this.currentBreadcrumbs.asObservable();

  public breadcrumbs: any = [];

  constructor(private titleTranslations: BreadcrumbTranslationService, private storage: StorageService) {
    this.storage.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe((club: Club) => {
        this.selectedClubId = (club !== null) ? club.id : 0;
        this.loadBreadcrumbs();
      });
  }

  public ngOnDestroy(): void {
  }

  /**
   * Set new list of clubs
   */
  public setCurrentPage(page: string): void {
    this.currentPage.next(page);
  }

  /**
   * Sets a new set of breadcrumbs
   */
  public setCurrentBreadcrumbs(arr: Array<string> = ['products', 'crm'], id?: any): any {
    const finalArray = [];
    if (id) {
      this.currentId = id;
    }
    this.loadBreadcrumbs();
    this.breadcrumbs.filter(el => {
      if (arr.includes(el['page'])) {
        finalArray.push(el);
      }
    });
    this.currentBreadcrumbs.next(finalArray);
  }

  /**
   * Load the breadcrumbs
   */
  public loadBreadcrumbs(): void {
    this.breadcrumbs = [
      {page: 'globalSettings', title: this.titleTranslations.i18nGlobalSettings, link: `/`, icon: '#esf-icon-globe'},
      {page: 'globalClubList', title: this.titleTranslations.i18nClubs, icon: '#esf-icon-user-data'},
      {page: 'globalUserList', title: this.titleTranslations.i18nUsers, icon: '#esf-icon-user-data'},
      {page: 'products', title: this.titleTranslations.i18nProducts, icon: '#esf-icon-grid'},
      {page: 'crm', title: this.titleTranslations.i18nCRM, link: `/club/${this.selectedClubId}`, icon: '#esf-icon-user-data'},
      {page: 'clubSettings', title: this.titleTranslations.i18nClubSettings, icon: '#esf-icon-club-overview'},
      {page: 'clubAttributes', title: this.titleTranslations.i18nClubAttributes, icon: '#esf-icon-attributes'},
      {page: 'clubUsers', title: this.titleTranslations.i18nClubUsers, icon: '#esf-icon-user-data'},
      {page: 'imports', title: this.titleTranslations.i18nImports, icon: '#esf-icon-users-add-small'},
      {page: 'customerSearch', title: this.titleTranslations.i18nCustomerSearch, icon: '#esf-icon-user-search'},
      {page: 'customerProfile', title: this.titleTranslations.i18nCustomerProfile, icon: '#esf-icon-user'},
      {page: 'lastContacts', title: this.titleTranslations.i18nLastContacts, icon: '#esf-icon-conversation'},
      {page: 'merchandising', title: this.titleTranslations.i18nMerchandising, icon: '#esf-icon-merch'},
      {page: 'ticketing', title: this.titleTranslations.i18nTicketing, icon: '#esf-icon-ticket'},
      {page: 'campaignActivity', title: this.titleTranslations.i18nCampaignActivity, icon: '#esf-icon-megaphone-small'},
      {page: 'userProfile', title: this.titleTranslations.i18nUserProfile, icon: '#esf-icon-user-small'},
      {page: 'homeOpenReminders', title: this.titleTranslations.i18nReminders, icon: '#esf-icon-bell'},
      {page: 'homeResolvedReminders', title: this.titleTranslations.i18nReminders, icon: '#esf-icon-bell'},
      {page: 'tixxSelectOverview', title: this.titleTranslations.i18nTixxSelect, icon: '#esf-icon-clover-leaf-16'},
      {page: 'tixxSelectEvent', title: this.titleTranslations.i18nTixxSelect, icon: '#esf-icon-clover-leaf-16'},
      {page: 'lotteryPreparation', title: this.titleTranslations.i18nTixxSelect, icon: '#esf-icon-clover-leaf-16'},
      {page: 'lotteryExecution', title: this.titleTranslations.i18nTixxSelect, icon: '#esf-icon-clover-leaf-16'},
      {page: 'lotteryDashboard', title: this.titleTranslations.i18nTixxSelect, icon: '#esf-icon-clover-leaf-16'},
      {page: 'customerMerger', title: this.titleTranslations.i18nCustomerMerger, icon: '#esf-icon-people-two'},
      {page: 'tixxFanPortal', title: this.titleTranslations.i18nTixxFanPortal, icon: '#esf-icon-people-two'},
    ];
  }

}
